import cn from "classnames";
import styles from "@/components/Game/Compass/Compass.module.sass";
import Image from "next/image";

import {Objects, useGameContext} from "@/context/GameContext";

const Parchment = ({parentStyle,className, ...props}) => {

	const {isMobile} = useGameContext()

	return (
		  <div className={cn(styles.parchment, className)} {...props}>
			  {/*Parchment*/}
			  <Image className={cn(parentStyle.parchment__image, 'parchment__image')} src={'/images/Game/Parchment/parchment.png'} alt={"Parchment"} id={Objects.PARCHMENT} width={158} height={271}/>
			  <Image className={parentStyle.parchment__image_empty} src={'/images/Game/Parchment/parchment_empty.png'} alt={"Parchment Empty"} width={158} height={271}/>

			  {/*Sparkles*/}
			  {isMobile !== undefined ? (isMobile ? <Image className={cn(parentStyle.parchment__sparkles, 'parchment__sparkles')} src={'/images/Game/Glow/sparkles.png'} alt={"Sparkles"} width={64} height={64}/>
					  : <Image className={cn(parentStyle.parchment__sparkles, 'parchment__sparkles')} src={'/images/Game/Glow/sparkles.gif'} alt={"Sparkles"} width={64} height={64}/>) : null}
		  </div>
	);
}
export default Parchment;